import React, { useState } from "react";
import { ExternalLink } from "lucide-react";
import TopCompanies from "./TopCompanies.jsx";

// Top 3 US companies by market cap (mid-2026). Edit any time.
const TOP_3 = [
  { name: "NVIDIA", ticker: "NVDA", symbol: "NASDAQ:NVDA" },
  { name: "Alphabet", ticker: "GOOGL", symbol: "NASDAQ:GOOGL" },
  { name: "Apple Inc.", ticker: "AAPL", symbol: "NASDAQ:AAPL" },
];

// Placeholder announcements. `daysAgo` keeps the dates fresh whenever you open the page.
// Later: replace with real filings / news, personalized per user.
const ANNOUNCEMENTS = [
  { company: "Apple Inc.", daysAgo: 1, title: "Investor Conference", summary: "Management will take part in investor meetings over the coming weeks." },
  { company: "NVIDIA", daysAgo: 1, title: "Current Report (Form 8-K)", summary: "NVIDIA filed a current report with the SEC covering a recent corporate update." },
  { company: "Microsoft", daysAgo: 2, title: "Quarterly Dividend Declaration", summary: "The board declared its regular quarterly dividend, payable to shareholders of record." },
  { company: "Tesla", daysAgo: 2, title: "Earnings Call Scheduled", summary: "Tesla announced the date and time of its upcoming quarterly earnings webcast." },
  { company: "Amazon", daysAgo: 3, title: "Quarterly Report (Form 10-Q)", summary: "Amazon filed its quarterly report with the SEC, including updated financial statements." },
  { company: "JPMorgan", daysAgo: 4, title: "Share Repurchase Update", summary: "JPMorgan provided an update on its ongoing share repurchase program." },
  { company: "Alphabet", daysAgo: 4, title: "Annual Meeting Materials Published", summary: "Proxy materials for the upcoming annual meeting of shareholders are now available." },
  { company: "Meta", daysAgo: 5, title: "Insider Transaction (Form 4)", summary: "An executive officer reported a transaction in company shares." },
  { company: "Eli Lilly", daysAgo: 6, title: "Press Release: Pipeline Update", summary: "Eli Lilly shared an update on programs in its clinical development pipeline." },
  { company: "Visa", daysAgo: 7, title: "Investor Presentation Posted", summary: "Visa posted a new investor presentation on its investor relations website." },
  { company: "NVIDIA", daysAgo: 8, title: "Analyst Day Announcement", summary: "Details of an upcoming analyst and investor event were announced." },
  { company: "Microsoft", daysAgo: 9, title: "Current Report (Form 8-K)", summary: "Microsoft filed a current report with the SEC regarding a corporate event." },
  { company: "Apple Inc.", daysAgo: 11, title: "Quarterly Report (Form 10-Q)", summary: "Apple filed its latest quarterly report with the SEC." },
  { company: "Tesla", daysAgo: 12, title: "Insider Transaction (Form 4)", summary: "A director reported a change in beneficial ownership of company shares." },
];

const PAGE_SIZE = 6;

function dateLabel(daysAgo) {
  if (daysAgo === 0) return "TODAY";
  if (daysAgo === 1) return "YESTERDAY";
  const d = new Date();
  d.setDate(d.getDate() - daysAgo);
  return d
    .toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })
    .toUpperCase();
}

export default function Feed({ user }) {
  const [visible, setVisible] = useState(PAGE_SIZE);

  const shown = ANNOUNCEMENTS.slice(0, visible);

  // Group the visible items by date label (items are already newest first)
  const groups = [];
  shown.forEach((item) => {
    const label = dateLabel(item.daysAgo);
    const last = groups[groups.length - 1];
    if (last && last.label === label) last.items.push(item);
    else groups.push({ label, items: [item] });
  });

  return (
    <main className="page-bg">
      <div className="dash-main-content">
        {/* Top 3 companies with TradingView charts */}
        <TopCompanies title="Top 3 companies" companies={TOP_3} />

        <div>
            <div className="top-bar">
              <div className="watchlist-title">
                <span>Feed</span>
              </div>
            </div>

            {user ? (
              <>
                <p className="feed-empty">Nothing new since your last visit.</p>
                <div className="last-visit">
                  <span>last visit</span>
                </div>
              </>
            ) : (
              <p className="text-muted mb-4">
                Sign up to get a feed personalized to the companies you follow.
              </p>
            )}

            {groups.map((group) => (
              <section key={group.label} className="mb-4">
                <div className="feed-date">{group.label}</div>
                <div className="d-flex flex-column gap-3">
                  {group.items.map((item, i) => (
                    <article key={`${item.company}-${i}`} className="card feed-item">
                      <a
                        href="#"
                        className="feed-company"
                        onClick={(e) => e.preventDefault()}
                      >
                        {item.company} <ExternalLink size={15} />
                      </a>
                      <a
                        href="#"
                        className="feed-title"
                        onClick={(e) => e.preventDefault()}
                      >
                        {item.title}
                      </a>
                      <p className="feed-summary">{item.summary}</p>
                    </article>
                  ))}
                </div>
              </section>
            ))}

            {visible < ANNOUNCEMENTS.length && (
              <button
                className="show-more-btn"
                onClick={() => setVisible(visible + PAGE_SIZE)}
              >
                SHOW MORE
              </button>
            )}

            <p className="text-muted small mt-4 mb-0">Sample content for layout purposes.</p>
          </div>
      </div>
    </main>
  );
}